















































































































































































































































































/** @format */

import { Vue, Component, Watch, Mixins, Prop } from 'vue-property-decorator';
import Utils from '@/utils/common';
import moment from 'moment';
import * as _ from 'lodash';
import { onlyFloat } from '@/utils/validator-util';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import GoBackWithCloseTab from '@/common/mixins/go-back-with-close-tab';
import {
  queryParkingSpaceEditInfo,
  queryParkingSpaceAddUpdate,
  queryParkingSpaceAreaInfo
} from '@/api/parking-space-list';
// eslint-disable-next-line no-unused-vars
import { PARKING_SPACE_LIST } from '../../router-names';
import {
  useTypeMap,
  categoryMap,
  useStatusMap,
  spaceTypeMap,
  statusMap,
  lockedMap
} from '@/types/parking-space-management/dictionaries';
import { isShiDaill } from '@/utils/env';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: {
    ParkingLotSearch
  }
})
export default class EnergyRecordDetail extends Mixins(GoBackWithCloseTab) {
  @Prop({ default: false })
  isEdit!: boolean;
  // 车位用途
  useTypeList = Utils.toLabelVal(useTypeMap);
  // 车位类别
  categoryList = Utils.toLabelVal(categoryMap);
  // 使用状态
  useStatusList = Utils.toLabelVal(useStatusMap);
  // 车位类型
  spaceTypeList = Utils.toLabelVal(spaceTypeMap);
  // 车位状态
  statusList = Utils.toLabelVal(statusMap);
  // 是否为地锁车位
  lockedList = Utils.toLabelVal(lockedMap);
  // form布局
  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 }
    }
  };
  isshidaill: boolean = isShiDaill;
  categoryLLList = _.filter(Utils.toLabelVal(categoryMap), function(o) {
    return o.value != '01';
  });
  useTypeLLList = _.filter(Utils.toLabelVal(useTypeMap), function(o) {
    return o.value != '01';
  });
  centerFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 14,
        offset: 10
      }
    }
  };

  private spaceId: string = ''; // -1 为新增，其他为修改

  private loading: boolean = false; // 接口状态

  private form: any; // form表单
  private onlyFloat = onlyFloat;

  private areaList: any = [];

  private filterParam: any = {
    spaceId: this.spaceId,
    parkId: '',
    areaId: '',
    code: '', // 车位号
    category: '', // 车位类别
    useType: '', // 车位用途
    useStatus: '', // 使用状态
    number: '', // 泊车数量
    spaceType: '', // 车位类型
    useArea: '', // 车位面积
    status: '01', // 车位状态
    isLock: '01', // 是否为地锁车位
    lockCode: '', // 车位锁编号
    lockBinding: '' // 车位锁绑定码
  };
  // 设置默认值;
  status = '01';
  queryParkingSpaceAreaList: any;
  isDetailFlag: boolean = false;
  async created() {
    // 初始化form
    this.form = this.$form.createForm(this);
    this.init();
  }
  // activated() {
  //   this.init();
  // }
  init() {
    const spaceId = this.$route.params.id;
    this.spaceId = spaceId;
    console.log(' this.$route.params', this.$route.params, this.$route);
    if (
      this.$route.params.useStatus === '02' ||
      this.$route.params.useStatus === '04' ||
      this.$route.query.useStatus === '02' ||
      this.$route.query.useStatus === '04'
    ) {
      this.isDetailFlag = true;
    } else {
      this.isDetailFlag = false;
    }
    // 获取修改数据
    this.queryUpdateData();
    this.queryParkingSpaceAreaList = _.debounce(this.queryParkingSpaceAreaInfo, 500);
  }
  // 车场变化，请求区域
  @Watch('filterParam.parkId')
  onChangeParkId(newVal: string, oldVal: string) {
    this.queryParkingSpaceAreaList();
  }

  changeParking(val: any) {
    this.filterParam.parkId = val;
  }

  changeIsLock(e: any) {
    this.filterParam.isLock = e.target.value;
  }

  // 获取区域数据
  async queryParkingSpaceAreaInfo() {
    try {
      const { parkId } = this.filterParam;
      const { data } = await queryParkingSpaceAreaInfo({
        parkId
      });
      this.areaList = data;
    } catch (error) {
      this.$message.error(error.msg);
    }
  }

  // 设置面包屑
  // private setNavsTitle(code: string) {
  //   const title = code == '-1' ? '车位新增' : '车位修改'
  //   this.navs.push({
  //     label: title,
  //   })
  // }

  // 获取修改数据
  private async queryUpdateData() {
    if (this.spaceId === '-1') {
      return;
    }
    try {
      const { data } = await queryParkingSpaceEditInfo({ spaceId: this.spaceId });
      this.filterParam = { ...data };
      console.log('---->>>');
    } catch (error) {
      this.$message.error(error.msg);
    }
  }

  // 处理车位类别为非固定车位时，车辆类型为普通、数量为1，车位用途为出租
  private changeCategory(e: any) {
    const clinetValue = e.target.value;
    this.filterParam.category = clinetValue;
    if (clinetValue === '04') {
      this.filterParam.spaceType = '02';
      (this.filterParam.useType = '02'), (this.filterParam.useStatus = '03');
      this.form.setFieldsValue({
        'filterParam.spaceType': '02',
        'filterParam.number': '1',
        'filterParam.useType': '02',
        'filterParam.useStatus': '03'
      });
    }
  }

  // 处理使用状态改变
  private changeUseStatus(e: any) {
    const clinetValue = e.target.value;
    this.filterParam.useStatus = clinetValue;
    if (clinetValue === '02' || clinetValue === '04') {
      (this.filterParam.status = '01'),
        this.form.setFieldsValue({
          'filterParam.status': '01'
        });
    }
  }

  // 处理车位用途为产权时
  private changeUseType(e: any) {
    const clinetValue = e.target.value;
    this.filterParam.useType = clinetValue;
    if (clinetValue === '01') {
      this.filterParam.useStatus = '01';
      this.form.setFieldsValue({
        'filterParam.useStatus': '01'
      });
    }
    if (clinetValue === '02') {
      this.filterParam.useStatus = '03';
      this.form.setFieldsValue({
        'filterParam.useStatus': '03'
      });
    }
    if (clinetValue === '03') {
      this.filterParam.useStatus = '05';
      this.form.setFieldsValue({
        'filterParam.useStatus': '05'
      });
    }
  }

  // 处理车位类型为字母类型时
  private changeSpaceType(e: any) {
    const clinetValue = e.target.value;
    this.filterParam.spaceType = clinetValue;
    if (clinetValue !== '03') {
      this.form.setFieldsValue({
        'filterParam.number': '1'
      });
    }
  }
  // 提交
  private handleSubmit(e: any) {
    e.preventDefault();
    const { parkId } = this.filterParam;
    // if (!parkId) {
    //   this.$message.warning('请选择车场')
    //   return
    // }
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        const { filterParam } = values;
        this.addAndUpdate(filterParam);
      }
    });
  }

  // 添加和修改接口
  private async addAndUpdate(params: object) {
    this.loading = true;
    const { parkId, spaceId } = this.filterParam;
    const options = {
      parkId,
      ...params,
      spaceId: spaceId === '-1' ? '' : spaceId
    };
    try {
      const { data } = await queryParkingSpaceAddUpdate({ ...options });
      this.$message.success(`${this.spaceId === '-1' ? '新增成功' : '修改成功'}`);
      setTimeout(() => {
        this.toBack();
      }, 1000);
    } catch (error) {
      this.$message.error(error.msg || `${this.spaceId === '-1' ? '新增失败' : '修改失败'}`);
    } finally {
      this.loading = false;
    }
  }
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  // 返回
  private toBack() {
    this.closeCurrentTab();
    this.form.resetFields();
    this.filterParam.parkId = '';
    // this.$router.replace({
    //   name: routeNames.PARKING_SPACE_LIST,
    // })
    // this.goBack('/smart-parking/parking-space-management/parking-space-list');
    this.closeCurrentTab();
    // 页面返回
    this.$router.replace({
      name: PARKING_SPACE_LIST
    });
  }
}
